export default __webpack_public_path__ + "953555118c8f835b30db43e927efe1b3.webp";